var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowSmRightIcon } from '@heroicons/react/solid';
import { Link } from 'react-router-dom';
export var Breadcrumb = function (_a) {
    var paths = _a.paths;
    return (_jsx("nav", __assign({ "aria-label": "breadcrumb", className: "flex" }, { children: _jsx("ol", __assign({ className: "inline-flex items-center space-x-1 md:space-x-3" }, { children: paths === null || paths === void 0 ? void 0 : paths.map(function (path, index) {
                var isLast = index === paths.length - 1;
                return (_jsx("li", __assign({ className: "inline-flex items-center ".concat(isLast ? 'text-textMid' : 'text-secondary') }, { children: !isLast ? (_jsx(_Fragment, { children: path.url ? (_jsxs(Link, __assign({ to: {
                                pathname: path.url,
                                state: path.state,
                            }, className: "inline-flex items-center text-sm font-medium hover:text-gray-900" }, { children: [path.name, _jsx(ArrowSmRightIcon, { className: "text-textMid ml-3 h-5 w-5" })] }))) : (_jsxs("span", __assign({ className: "inline-flex cursor-not-allowed items-center text-sm font-medium" }, { children: [path.name, _jsx(ArrowSmRightIcon, { className: "text-textMid ml-3 h-5 w-5" })] }))) })) : (_jsx("span", __assign({ className: "text-sm font-medium" }, { children: path.name }))) }), index));
            }) })) })));
};
//# sourceMappingURL=index.js.map